import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	label: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.filters.reset-button.label',
		defaultMessage: 'Reset',
		description: 'Label for reset filters button',
	},
	resetFilterLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.filters.reset-button.reset-filter-label',
		defaultMessage: 'Reset Filters',
		description:
			'It is an aria label for reset filters button that becomes available after selecting any option from the dropdowns',
	},
});
